import {RuleBundleType, RuleOrWorkflowBundleType} from '@frontapp/workflows/rules';
import React, {FC} from 'react';

import {NewPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ActivityMacroPill} from './activityMacroPill';
import {ActivityRulePillContainer} from './activityRulePillContainer';

/*
 * Props.
 */

export interface ActivityRuleOrMacroPillProps {
  panelId?: NewPanelId;
  ruleName: string;
  ruleId: number;
  ruleBundleId?: number;
  ruleBundleType?: RuleOrWorkflowBundleType;
  ruleNamespace?: string;
  onClickTrackingCallback?: () => void;
}

/*
 * Component.
 */

export const ActivityRuleOrMacroPill: FC<ActivityRuleOrMacroPillProps> = (props) =>
  props.ruleBundleType === RuleBundleType.MACRO ? (
    <ActivityMacroPill {...props} />
  ) : (
    <ActivityRulePillContainer {...props} />
  );
